import { Currency, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import {
  CustomerStat,
  FinancialStat,
  PaymentTypeStat,
  Response,
  TransactionStat,
} from '../types';

export const dashboardApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCustomersList: build.query<Response<CustomerStat>, string>({
      query: (query) => ({
        url: `/v1/reports/applications-stats-by-status${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getTransactionsList: build.query<Response<TransactionStat>, string>({
      query: (query) => ({
        url: `/v1/reports/transactions-stats-by-status${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getFinancialList: build.query<{ data: FinancialStat }, string>({
      query: (query) => ({
        url: `/v1/reports/finance-stats${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getPaymentTypesList: build.query<Response<PaymentTypeStat>, string>({
      query: (query) => ({
        url: `/v1/reports/transactions-stats-by-payment-type${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getDashboardBaseCurrency: build.query<{ data: Currency }, void>({
      query: () => ({
        url: '/v1/currencies/base',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetCustomersListQuery,
  useLazyGetTransactionsListQuery,
  useLazyGetFinancialListQuery,
  useLazyGetPaymentTypesListQuery,
  useLazyGetDashboardBaseCurrencyQuery,
} = dashboardApi;

export const {
  endpoints: {
    getCustomersList,
    getTransactionsList,
    getFinancialList,
    getPaymentTypesList,
    getDashboardBaseCurrency,
  },
} = dashboardApi;
